import { removeHeaderPromotionClosedCookie as removeCookie } from './helpers';
import useContext from './useHeaderPromotionContext';

export { default as HeaderPromotionLine } from './HeaderPromotionLine';
export const removeHeaderPromotionClosedCookie = removeCookie;
export const useHeaderPromotionContext = useContext;
